import React, { FunctionComponent } from 'react';
import cx from 'clsx';
import { ResponsiveImage, Typography } from 'components/elements';
import styles from './FeaturesTile.module.scss';
import { WPAcfFeature } from 'types/acf/features';

interface OwnProps {
  data: WPAcfFeature | null;
  align: 'left' | 'center' | 'right';
}

type FeaturesTileProps = JSX.IntrinsicElements['div'] & OwnProps;

const FeaturesTile: FunctionComponent<FeaturesTileProps> = props => {
  const { data, align } = props;
  const { title, description, image } = data || {};

  if (!data || !image) {
    return null;
  }

  const containerClassName = cx(styles.container, {
    [styles[align]]: align,
  });

  return (
    <div className={containerClassName}>
      <div className={styles.image}>
        <ResponsiveImage
          desktopImage={{ config: image, imgProps: { sizes: '100px', componentHeight: true } }}
          mobileImage={{ config: image, imgProps: { sizes: '100px', componentHeight: true } }}
        />
      </div>
      {title && (
        <Typography className={styles.header} mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h3" align={align}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography className={styles.description} mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="p" align={align}>
          {description}
        </Typography>
      )}
    </div>
  );
};

export default FeaturesTile;
